import angular from 'angular';

class LoadScriptController {

  // Ensure all dependencies are correctly injected for minification
  static $inject = ['$rootScope', '$compile'];

  /** @ngInject */
  constructor($rootScope, $compile) {

    Object.assign(this, {
      $rootScope, $compile
    });

  }
}

class LoadScriptDirective {

  constructor() {
    this.restrict = "A";
    // this.replace = true;
    this.scope = {
      src: '@?',
      data: '=?'
    };
    this.controller = LoadScriptController;
  }

  link(scope, element, attrs, ctrl) {
    var t = document.createElement("script");
      t.type = "text/javascript";
      t.src = scope.src;
      if(attrs.async) {
        t.async = true;
      }
      if(scope.data) {
        Object.keys(scope.data).forEach(key => {
          t.setAttribute(`data-${key}`, scope.data[key]);
        });
      }
      element.append(t);
      // success event
      t.addEventListener("load", () => attrs.onload);
  }

  // static directiveFactory() {
  //   return new LoadScriptDirective();
  // }
}

export default angular
.module('loadScript.directive', [])
.directive('loadScript', () => new LoadScriptDirective())
.name;
